import { render } from "./MyFooter.vue?vue&type=template&id=5920cecb&scoped=true"
const script = {}

import "./MyFooter.vue?vue&type=style&index=0&id=5920cecb&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5920cecb"]])

export default __exports__